import {ApiModel} from '@models/api-model';
import {LaboratoryDocumentsNamespace} from '@components/laboratory-documents/laboratory-documents.namespace';
import {UploadedFile} from '@interfaces/file.interface';
import {DateService} from '@services/date.service';

export class LaboratoryDocument extends ApiModel<LaboratoryDocumentsNamespace.DocumentApiData> {
    id: number;
    type: LaboratoryDocumentsNamespace.DocumentTypeEnum;
    number: string;
    dateIssue: string;
    dateEnd: string;
    filesUrls: UploadedFile[];

    /**
     * Просрочена ли дата окончания?
     */
    isDateEndExpired;

    constructor(
        _data,
        public name: string
    ) {
        super(_data);
        this.setAttributes();
    }

    setAttributes() {
        this.id = this.rawData.id;
        this.type = this.rawData.type;
        this.dateIssue = this.rawData.date_issue;
        this.dateEnd = this.rawData.date_end;

        if (this.dateEnd && !DateService.isDateEndActual(this.dateEnd)) {
            this.isDateEndExpired = true;
        }

        this.number = this.rawData.number;
        this.filesUrls = this.rawData.files ? this.rawData.files : [];
    }
}
